export const SET_COMPANY_REGISTRATION_DATA = 'SET_COMPANY_REGISTRATION_DATA'
export const SET_COMPANY_DATA = 'SET_COMPANY_DATA'
